module.exports = __webpack_public_path__ + "fonts/b9077621ce786b55c176a61456bfc077-Roboto-Regular.eot";